import { useTranslation } from 'react-i18next';
import BllinkUtils from '../../../../common/utils/utils';
import { StyledTable } from '../CreditCardChoice.styled';
import CardChoiceRadio from "./CardChoiceRadio";

const CardChoice = ({ radioArr, disabled, current, onRadioChange }) => {
    const { t } = useTranslation();

    const columns = [
        {
            Header: '',
            id: 'radioBtns',
            Cell: row => {
                return (
                    <CardChoiceRadio 
                        disabled={disabled} 
                        onChange={onRadioChange} 
                        value={row.row.original.paymentID}
                        checked={current == row.row.original.paymentID} 
                    />  
                )
            }
        },
        {
            Header: t('creditCardChoice.tableHeaders.name'),
            id: 'name',
            accessor: 'name',
        },
        {
            Header: t('creditCardChoice.tableHeaders.lastUsed'),
            id: 'lastUsed',
            accessor: 'lastUsed',
            Cell: row => {
                const dateParsed = BllinkUtils.BllinkTime.parseDate(row.row.original.lastUsed);
                return <>{dateParsed}</>
            }
        },
        {
            Header: t('creditCardChoice.tableHeaders.cardLast4Digits'),
            id: 'cardLast4Digits',
            accessor: 'cardLast4Digits',
        },
        {
            Header: t('creditCardChoice.tableHeaders.phone'),
            id: 'phone',
            accessor: 'phone'
        },
        {
            Header: t('creditCardChoice.tableHeaders.email'),
            id: 'email',
            accessor: 'email'
        },
        {
            Header: t('creditCardChoice.tableHeaders.expiry'),
            id: 'expiry',
            accessor: 'expiry'
        },
    ];

    return (
        <StyledTable 
            columns={columns}
            data={radioArr}
            initialSorting={[{
                id: 'lastUsed',
                desc: true
            }]}
        />
    );
};

export default CardChoice;
